class Liquidacion{
    constructor(id, institucion_id, periodo, tipo){
        this.id = id;
        this.institucion_id = institucion_id;
        this.periodo = periodo;
        this.tipo = tipo;
    }
}
export default Liquidacion;